import apiCrud from '../../abstract/api-crud';
import httpBuildQuery from '../../../procedures/http-build-query';

const baseUri = `${ import.meta.env.VITE_SITE_URL }/bookkeepings/work-parameters`;
export const modelName = 'workparameters';

export default {
  ...apiCrud({ baseUri, modelName }),

  index: async (query) => {
    let response = await axios.get(`${ baseUri }/with-types${ httpBuildQuery(query) }`);
    return {
      ...response
    };
  },
};
